import {Signals} from "@/Imports";
import Facade from "@/Facade";
import Config from "@/config/Config";
import * as PIXI from "pixi.js";

export default class InactivityTimerManager {
    enabled = false;
    timerId = null;
    timerTime = 0;
    terminateTimerTime = 60;
    roundActive = false;
    showPopup = false;

    constructor() {
        Signals.UIisReady.add(this.onInit.bind(this));
        Signals.roundStart.add(this.onRoundStart.bind(this));
        Signals.roundEnd.add(this.onRoundEnd.bind(this));
        Signals.gameMessage.add(this.handleGameMessage.bind(this)); // Centralize game message handling
    }

    onInit() {
        // Set timer time, fallback to default if Facade.model.in_t is undefined or 0
        this.timerTime = Facade.model?.in_t || 0;
        if(this.timerTime > 0){
            this.enabled = true;
        }
        this.startTimer();
    }

    onRoundStart() {
        if(!this.enabled) return;

        this.roundActive = true;
        this.startTimer()
    }

    onRoundEnd() {
        if(!this.enabled) return;

        this.roundActive = false;
        // Trigger inactivity popup if bets are not placed and popup should be shown
        if (this.showPopup) {
            //CANCEL PENDING BETS
            Signals.gameMessage.dispatch({
                message: 'cancel',
                cell: 1,
            });
            Signals.gameMessage.dispatch({
                message: 'cancel',
                cell: 2,
            });
            this.triggerInactivityPopup();
        }
    }

    /**
     * Centralized handler for all game messages related to bets and inactivity timer.
     */
    handleGameMessage(data) {
        this.resetCurrentTimer(data);
    }

    /**
     * Reset the inactivity timer if a bet is placed or canceled.
     * @param {Object} data - The message data containing message type.
     */
    resetCurrentTimer(data) {
        if (this.timerId !== null && ["bet", "cancel"].includes(data.message)) {
            // Clear existing timer and start a new one
            clearTimeout(this.timerId);
            this.timerId = null;
            this.startTimer();
        }
    }

    /**
     * Start the inactivity timer if it isn't already running.
     */
    startTimer() {
        if (!this.enabled || this.timerId !== null) return;

        this.timerId = setTimeout(() => {
            this.showPopup = true;
            this.timerId = null;
        }, this.timerTime * 1000);
    }

    /**
     * Trigger inactivity popup and reset state.
     */
    triggerInactivityPopup() {
        if(!this.enabled) return;

        let terminateTimerId = setTimeout(() => {
            Signals.terminateWSClient.dispatch();
            document.dispatchEvent(new CustomEvent("closeModal"))
            Signals.sessionTimeout.dispatch()
        },  this.terminateTimerTime * 1000)

        const data = {
            "msg": {
                "c": 911,
                "title": 'inactivityDialogTitle',
                "msg": 'inactivityDialogDescription',
                "b": [
                    {
                        "text": "continue",
                        "action": (closeModal) => {
                            this.showPopup = false;
                            clearTimeout(terminateTimerId);
                            this.removeGameBlur()
                            closeModal();
                        }
                    },
                    {"text": "quit", "action": 'reload'},
                ]
            },
        }

        let event = new CustomEvent("errorMessage", {detail: {value: data}})

        this.setGameBlur();
        document.dispatchEvent(event)
    }

    setGameBlur() {
        Config.app.stage.filters = [new PIXI.filters.BlurFilter()];
    }

    removeGameBlur() {
        Config.app.stage.filters = null;
    }
}